import config from '@angular/config';

import maybeWarnAboutDeleting from '../../../shiftTasks/helpers/maybeWarnAboutDeleting';
import trashIconSvg from '../../../assets/svg/UI/trash.svg';
import closeIconSvg from '../../../assets/svg/UI/close.svg';
import copyIconSvg from '../../../assets/svg/UI/copy.svg';

import viewTaskTemplateSidebarUrl from './viewTaskTemplateSidebar.html';

class ViewTaskTemplateSidebarCtrl {
  trashIconSvg = trashIconSvg;
  closeIconSvg = closeIconSvg;
  copyIconSvg = copyIconSvg;

  constructor(AlertService, Authentication, TaskTemplatesService, $uibModal, $state) {
    'ngInject';

    Object.assign(this, { AlertService, Authentication, TaskTemplatesService, $uibModal, $state });
  }

  $onInit() {
    this.areAttachmentsEnabled = config.SHIFT_TASK_ATTACHMENTS_ENABLED;

    this.loadTemplateDetails();
  }

  async loadTemplateDetails() {
    this.template = await this.TaskTemplatesService.loadTemplateDetails(this.templateId);
  }

  async deleteTaskTemplate() {
    await this.maybeWarnAboutDeletingTaskTemplate();
    this.dismiss();
    await this.TaskTemplatesService.remove(this.templateId);
  }

  maybeWarnAboutDeletingTaskTemplate() {
    return maybeWarnAboutDeleting(this.Authentication, this.$uibModal);
  }

  dismiss() {
    this.modal.dismiss();
  }

  async editTemplate() {
    this.modal.close();

    this.editTaskTemplate({ sourceTemplate: this.template });
  }

  hasSubtasks() {
    return this.template?.subtasks?.some((subtask) => subtask.title.trim());
  }

  async copyTemplate() {
    this.modal.close();
    // eslint-disable-next-line no-unused-vars
    this.copyTaskTemplate({ sourceTemplate: this.template });
  }

  hasAttachments() {
    return Boolean(this.areAttachmentsEnabled && this.template?.attachments?.length);
  }
}

export default {
  templateUrl: viewTaskTemplateSidebarUrl,
  controller: ViewTaskTemplateSidebarCtrl,
  controllerAs: 'ctrl',
  bindings: {
    modal: '<',
    templateId: '<',
    copyTaskTemplate: '&',
    editTaskTemplate: '&',
  },
};
